import { modals } from '@mantine/modals';
import type { TranslateFn } from '@newo/localization';
import CreatorChatFlowInactivityModal from '../components/CreatorChatFlowInactivityModal';

const MODAL_ID = 'creator-chat-flow-inactivity';

export const openCreatorChatFlowInactivityModal = (
	description: string,
	translate: TranslateFn
): void => {
	modals.open({
		centered: true,
		closeOnClickOutside: true,
		closeOnEscape: true,
		modalId: MODAL_ID,
		padding: 28,
		radius: 24,
		size: 'auto',
		title: null,
		withCloseButton: true,
		children: (
			<CreatorChatFlowInactivityModal
				description={description}
				modalId={MODAL_ID}
				translate={translate}
			/>
		)
	});
};
